import React from 'react'
// libs
import { styled } from '@mui/material/styles'
// themes
import { colors } from 'themes'
// types
import { StepIconProps } from '@mui/material/StepIcon'

const Circle = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'completed'
})<{
  active?: boolean
  completed?: boolean
}>(({ active, completed }) => ({
  height: 46,
  width: 46,
  borderRadius: '50%',
  fontSize: 20,
  color: colors.white,
  backgroundColor: colors.gray270,
  boxShadow: '0 3px 5px 0px rgba(0, 0, 0, 0.26)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  ...(active && {
    color: colors.black,
    backgroundColor: colors.green600
  }),

  ...(completed && {
    backgroundColor: colors.green600
  })
}))

const StepIcon: React.FC<StepIconProps> = ({ active, completed, icon }) => {
  return (
    <Circle active={active} completed={completed}>
      {icon}
    </Circle>
  )
}

export default StepIcon
